var HyperLinkSupport = require("enyo-ui/HyperLinkSupport"),
    IconButton       = require("app/ui/IconButton"),
    frameThrottle    = require("enyo-perf/utils").frameThrottle,
    get              = require("object-path").get,
    icons            = require("app/theme/icons"),
    kind             = require("enyo/kind");

module.exports = kind(/** @lends  app.ui.MediaPlayer.PlayMediaButton.prototype */ {

    /**
     * @private
     */
    name: "app.ui.MediaPlayer.PlayMediaButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-media-player-play-media-button",

    /**
     * @private
     */
    mixins: [HyperLinkSupport],

    /**
     * The mediaItem
     *
     * @type  {?Object}
     * @public
     */
    mediaItem: null,

    /**
     * @private
     */
    handlers: {
        ontap: "onHyperlinkTap"
    },

    /**
     * @private
     */
    observers: {
        update: ["mediaItem"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var mediaItem = this.get("mediaItem");

        switch (get(mediaItem, "type", null)) {
            case "album_track":
            case "audio":
            case "podcast_episode":
                this.set("href", get(mediaItem, "links.player", null));
                this.set("icon", icons["app.MediaPlayer.PlayMediaButton.audio"]);
                break;
            case "episode":
            case "video":
                this.set("href", get(mediaItem, "links.player", null));
                this.set("icon", icons["app.MediaPlayer.PlayMediaButton.video"]);
                break;
            case "book":
            case "issue":
                this.set("href", get(mediaItem, "links.player", null));
                this.set("icon", icons["app.MediaPlayer.PlayMediaButton.text"]);
                break;
            case "photo":
                this.set("href", get(mediaItem, "links.player", null));
                this.set("icon", icons["app.MediaPlayer.PlayMediaButton.image"]);
                break;
            default:
                this.set("href", null);
                break;
        }
    },

    /**
     * Responds to a click on a hyperlink.
     *
     * @return  {boolean}  Stop propagation
     * @public
     */
    onHyperlinkTap: function() {
        var $appState           = this.app.$.state,
            $mediaPlayerManager = this.app.$.mediaPlayerManager,
            displayMode         = $appState.get("mediaPlayerDisplayMode"),
            mediaItem           = this.get("mediaItem"),
            mediaPlayer;

        // No href available
        if (!mediaItem) {
            return true;
        }

        switch (displayMode) {
            case "minimized":
                // Always navigate to the mediaItem
                $mediaPlayerManager.userNavToMediaItem(mediaItem);
                break;
            case "footer":
            case "maximized":
            default:
                // Same item but paused. Start playing it.
                if ($mediaPlayerManager.playerHasSameMediaItem(mediaItem)) {
                    if (!$appState.get("mediaPlayerPlaying")) {
                        mediaPlayer = $appState.get("mediaPlayer");

                        mediaPlayer
                            && mediaPlayer.play
                            && mediaPlayer.play();
                    }
                }

                // Different mediaItem, navigate to it
                else {
                    $mediaPlayerManager.userNavToMediaItem(mediaItem);
                }
                break;
        }

        return true;
    }

});
